import { Injectable } from '@angular/core';
declare var $: any;
@Injectable({
  providedIn: 'root'
})
export class SignalrService {
    private connection: any;
    private proxy: any;
constructor() {
  if (JSON.parse(localStorage.getItem('user')) === null) {
    localStorage.setItem('user', JSON.stringify({name: 'ahsan', id: '21', type: 'customerService'}));
  }
}
public initializeSignalRConnection(): void {
  // const signalRServerEndPoint = 'http://localhost:16194';
  const signalRServerEndPoint = 'https://www.foodizza.com';

        $.connection.hub.logging = true;
        this.connection = $.hubConnection(signalRServerEndPoint);
        this.proxy = this.connection.createHubProxy('requestLog');

        this.proxy.on('onConnected', (id, userName, allUsers, messages, userType) =>
         this.registerClient(id, userName, allUsers, messages, userType));

        this.proxy.on('onNewUserConnected', (id, name, userType) =>
        this.onNewUserConnected(this.proxy, id, name, userType));

        this.proxy.on('sendPrivateMessage', (id, name, userType, message) =>
        this.sendPrivateMessage(id, name, userType, message));
        // Request last Message
        this.proxy.on('GetLastMessages', (toUserID, currentChatMessages) =>
        this.getLastMessage(toUserID, currentChatMessages));
        this.proxy.on('PostToClient', (serverMessage) => this.onMessageReceived(serverMessage));

        this.connection.start({ withCredentials: false }).done((data: any) => {
            // this.proxy.server.connect('ahsan', '2');
            console.log('Connected to Notification Hub');
            this.broadcastMessage();
        }).catch((error: any) => {
            console.log('Notification Hub error -> ' + error);
        });
    }
    //when client to service
  private broadcastMessage(): void {
    const user = JSON.parse(localStorage.getItem('user'));
    this.proxy.invoke('Connect', user.name, user.id, user.type)
      .catch((error: any) => {
          console.log('broadcastMessage error -> ' + error);
    });
  }
  private registerClient(id, userName, allUsers, messages, userType): void {
    console.log(id, userName, allUsers, messages);
    debugger;
  }
  public getLastMessage(toUserID, currentChatMessages) {
    console.log('getLastMessage');
    console.log(toUserID, currentChatMessages);
  }
  public reqestLastMessage(fromUserID, toUserID) {
    this.proxy.invoke('RequestLastMessage', fromUserID, toUserID)
      .catch((error: any) => {
          console.log('Request Last Message error -> ' + error);
    });
  }
  public sendPrivateMessage(id, name, userType, message): void {
    console.log(id, name, userType, message);
    localStorage.setItem('client', JSON.stringify({id: id, userType: userType}));
    debugger;
  }
  private onMessageReceived(serverMessage: string) {
    console.log('New message received from Server: ' + serverMessage);
  }
  private onNewUserConnected(chatHub, id, name, userType) {
    console.log(id, name, userType);
    debugger;
  }
  public SendPrivateMessage(toUserId, userType, message) {
  this.proxy.invoke('SendPrivateMessage', toUserId, userType, message)
    .catch((error: any) => {
      console.log('broadcastMessage error -> ' + error);
    });
  }
  private registerClientMethods(chatHub): void {
    debugger;
    // Calls when user successfully logged in
    chatHub.client.onConnected = function (id, userName, allUsers, messages, userid) {
        // $('#hdId').val(id);
        // $('#hdUserName').val(userName);
        debugger;
        // Add All Users
        // for (i = 0; i < allUsers.length; i++) {
        //     //AddUser(chatHub, allUsers[i].ConnectionId, allUsers[i].UserName, userid);
        //     AddUser(chatHub, allUsers[i].UserID, allUsers[i].UserName, userid);
        // }

        // // Add Existing Messages
        // for (i = 0; i < messages.length; i++) {
        //     AddMessage(messages[i].UserName, messages[i].Message);
        // }

    }
  }
}
